import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Footer.css';
/*import { TiLocationOutline, TiPhone } from "react-icons/ti";*/
import { IoHomeSharp, IoCallSharp } from "react-icons/io5";
/* ROUTE IMPORTS 
import { NavLink, Switch, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import OfficeInfo from './components/OfficeInfo/OfficeInfo';
import Contact from './components/Contact/Contact';
import About from './components/About/About';*/


const Footer = () => {
    const navigate = useNavigate();

    const handleOfficePolicyClick = () => {
        navigate('/OfficeInfo/OfficePolicy');
        // Ensure page scrolls to top when office policy link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    const handlePrivacyPolicyClick = () => {
        navigate('/PrivacyPolicy');
        // Ensure page scrolls to top when privacy policy link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    const handleAboutClick = () => {
        navigate('/About');
        // Ensure page scrolls to top when Our Team link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    const handleHomeClick = () => {
        navigate('/');
        // Ensure page scrolls to top when Home link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    const handleContactClick = () => {
        navigate('/Contact');
        // Ensure page scrolls to top when contact link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    return (
        <section className="footer-section">
            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-about">
                        <h5 className="foothead">About Us</h5>
                        
                        <p>At Atlantic Primary Care, we've been serving our community for over 
                            20 years. Our mission is to provide high-quality, compassionate 
                            healthcare that addresses both your immediate needs and 
                            long-term wellness goals.</p>
                            
                        <div className="footer-review-section">
                            <a 
                                href="https://www.google.com/search?q=atlantic+primary+care+hanover+ma#lrd=0x89e49fd1ea755c0f:0xa4a6bff0c51c7ae0,1,,," 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="review-button"
                            >
                                Leave Us a Review
                            </a>
                        </div>
                    </div>
                    
                    <div className="footer-quick-links">
                        <h5 className="foothead">Quick Links</h5>
                        
                        <ul>
                            <li><button type="button" className="footer-link" onClick={handleHomeClick}>Home</button></li>
                            <li><button type="button" className="footer-link" onClick={handleAboutClick}>Our Team</button></li>
                            <li><button type="button" className="footer-link" onClick={handleOfficePolicyClick}>Office Policy</button></li>
                            <li><button type="button" className="footer-link" onClick={handlePrivacyPolicyClick}>Privacy Policy</button></li>
                            <li><button type="button" className="footer-link" onClick={handleContactClick}>Contact</button></li>
                        </ul>
                    </div>
                    <div className="footer-contact">
                        <h5 className="foothead">Contact</h5>
                        
                        <ul className="contact-info">
                            <li><IoHomeSharp className="foot-icon"/> 
                                <h6>Hanover Address</h6>
                                <p className="addy">
                                    <a href="https://maps.app.goo.gl/n1FBhxoD8u51u4aX8" target="_blank" rel="noopener noreferrer">
                                        105 Webster St Suite 9, Hanover, MA 02339
                                    </a>
                                </p>
                                {/* Weymouth Address commented out for future use */}
                                {/* <h6>Weymouth Address</h6>
                                <p className="addy">
                                    <a href="https://maps.app.goo.gl/9MMucpuUm9Szo2vu6" target="_blank" rel="noopener noreferrer">
                                        851 Main St Suite 25, Weymouth, MA 02190
                                    </a>
                                </p> */}
                            </li>
                            <li><IoCallSharp className="foot-icon"/> 
                                <h6>Phone:</h6>
                                <p className="phone">
                                    <a href="tel:7818715030">781-871-5030</a>
                                </p>
                                <h6>Fax:</h6>
                                <p className="fax">
                                    <a href="fax:7818715480">781-871-5480</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="row-dlex-justify-content-center">
                        <p className="copyright-details">Copyright &copy; 2025 All Rights Reserved by Atlantic Primary Care.</p>
                    </div>
                </div>
                {/*
                <Switch>
                    <Route path='/' exact component={() => <Header/>} />
                    <Route path='/About' exact component={() => <About/>} />
                    <Route path='/OfficeInfo/OfficePolicy' exact component={() => <OfficeInfo/>} />
                    <Route path='/Contact' exact component={() => <Contact/>} />
                </Switch>*/}
            </footer>
        </section>
            /*
           <footer className="footer" id="footer">
               <div className="top-footer-container">
                   <div class="row justify-content-md-center">
                        <div className="col-6">
                            <i className="footer-icon"><TiLocationOutline /></i>
                            <p className="footer-icon-info">
                                <h6 className="footer-icon-span">HANOVER OFFICE</h6> 
                                <br></br>105 Webster Street #9, Hanover, MA 02339 <br></br>
                                <span className="footer-icon-span">WEYMOUTH OFFICE</span> 
                                <br></br>851 Main Street, Suite 25, Weymouth, MA 02190 <br></br>
                            </p>
                        </div>
                  
                        <div className="col-6">
                            <i className="footer-icon"><TiPhone /></i>
                            <p className="footer-icon-info">
                                <span className="footer-icon-span">PHONE :</span> 781 - 871 - 5030<br></br>
                                <br></br>
                                <span className="footer-icon-span">FAX :</span> 781 - 871 - 5480<br></br>
                            </p>
                        </div>
                  
                    </div>
            </div>
               <hr></hr>
                <div className="main-footer-container">
                    <div className="row">
                        <h7 className="footer-logo">Title for Footer</h7>
                    </div>
                    <div className="row">
                    <div className="col">
                        <h6 className="footer-header">Hours</h6>
                        <ul className="office-hours">
                            <li className="location">WEYMOUTH OFFICE</li>
                            <li>Tuesday and : AM - PM</li>
                            <li>Saturday and Sunday: Closed</li>
                            <li className="location">HANOVER OFFICE</li>
                            <li>Tuesday and : AM - PM</li>
                        </ul>
                    </div>
                    <div className="col">
                        <h6 className="footer-header">Quick Links</h6>
                        <ul className="quick-links">
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Home</a></li>
                        </ul>
                    </div>
                    </div>
                </div>
        <hr></hr>
            <div className="copyright-container">
                <div className="row">
                    <div className="col-md-8 col-sm-6 col-xs-12">
                        <p className="copyright-details">Copyright &copy; 2021 All Rights Reserved by <a href="#">Link Here</a>.</p>
                    </div>
                    <div className="col-md-4 col-sm-6 col-xs-12">
                    <div className="quick-links">
                        <a href="#">Home</a>
                        <a href="#">Office Policy</a>
                        <a href="#">Contact</a>
                    </div>
                    </div>
                </div>
            </div>
           </footer>
            */
        
        /* ADD ROUTES TO LINKS ON FOOTER */
    )
}

export default Footer;
